import React from 'react'
import type {ComponentType} from 'react'

const WithoutPrismicPreviewProvider = ({children}: {children: React.ReactNode}) => <>{children}</>

const withoutPrismicPreview = <T extends ComponentType>(component: T): T => component

const componentResolverFromMap = () => null

export {
    WithoutPrismicPreviewProvider as PrismicPreviewProvider,
    withoutPrismicPreview as withPrismicPreview,
    withoutPrismicPreview as withPrismicUnpublishedPreview,
    withoutPrismicPreview as withPrismicPreviewResolver,
    componentResolverFromMap,
}
